import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import LogoutIcon from '@/assets/icons/logout.svg';
import { PlaneSendIcon } from '@/components/icons/plane-send';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';
import { useSafeBackNavigation } from '@/hooks/use-safe-back-navigation';

import { Stepper } from './stepper';
import { useValidatedStepper } from './use-validated-stepper';

export function Header() {
  const safeGoBack = useSafeBackNavigation();
  const { currentStep, isSubmitting, dismissResult } = useJobPostingContext();
  const { handleNext, handleStepClick, isLoading } = useValidatedStepper();

  const isResultStep = currentStep === 'result';

  const handleQuit = () => {
    if (isResultStep) {
      dismissResult();
    } else {
      safeGoBack();
    }
  };

  return (
    <div className="relative flex items-center justify-between bg-white p-2">
      <div className="flex items-center gap-4">
        <Button variant="secondary" type="button" onClick={handleQuit}>
          <img src={LogoutIcon} alt="" />
          <FormattedMessage
            defaultMessage="Quit"
            description="Button to quit the campaign creation"
          />
        </Button>

        <div className="hidden items-center gap-4 lg:flex">
          <Typography variant="body2">
            <FormattedMessage
              defaultMessage="Post to job boards"
              description="Title of the job posting form"
            />
          </Typography>
        </div>
      </div>

      {!isResultStep && (
        <div className="absolute left-1/2 -translate-x-1/2">
          <Stepper handleStepClick={handleStepClick} />
        </div>
      )}

      <div className="flex">
        {/* Next button for Job details, Pool and Spend steps */}
        {currentStep !== 'summary' && !isResultStep && (
          <Button
            type="button"
            onClick={() => void handleNext()}
            disabled={isLoading}
          >
            {isLoading && <Loader2 className="animate-spin" />}
            <FormattedMessage
              defaultMessage="Next"
              description="Button to navigate to the next page"
            />
          </Button>
        )}

        {/* Post button for post step */}
        {currentStep === 'summary' && (
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <Loader2 className="animate-spin" />
            ) : (
              <PlaneSendIcon className="text-white" />
            )}
            <FormattedMessage
              defaultMessage="Post Job"
              description="Button to post the campaign"
            />
          </Button>
        )}
      </div>
    </div>
  );
}
